import type { FaireBrandEntity } from "../../entity_types/brand";

// Textile Brand — real Faire brand (b_16o7r3v1y0), shown under an anonymized
// name. Identity metadata from ANALYTICS.CANONICAL.BRANDS; backs the
// ads-manager-2 "Textile Brand" real-brand variant (advertiser
// 9095933244058406210). The token and advertiser id are kept so the Snowflake
// refresh path in snowflakeQueries.ts still resolves; the location is
// generalized because a city plus this catalog would identify the brand.
export const b_16o7r3v1y0: FaireBrandEntity = {
  token: "b_16o7r3v1y0",
  type: "brand",
  name: "Textile Brand",
  description:
    "Printed textile and paper goods for the body and home, made from natural fibers and renewable materials.",
  location: "Pacific Northwest, USA",
  isTopShop: true,
  tags: ["home-decor", "textiles", "paper-goods"],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
